import fields from '@src/entities/ActionPath/includes/fields.json';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import React, { useMemo } from 'react';

const { initiativeType: initiativeTypeField } = fields;

/**
 * Field: InitiativeType
 *
 * Select the initiative type for the action path.
 *
 * @param assets
 * @param form
 * @returns {Element}
 * @constructor
 */
export function InitiativeType({
  assets = {},
  form = {
    validate: () => {},
  },
}) {
  const options = useMemo(() => {
    const theOptions = assets?.ListInitiativeTypes?.data
      ?.filter((item) => {
        return item?.isValid === true;
      })
      .map((option) => {
        return {
          label: option.codeDesc,
          value: option.codeId,
        };
      });

    return theOptions || [];
  }, [assets?.ListInitiativeTypes?.data]);

  return (
    <ErrorHandler location="src/features/ActionPaths/Wizard/components/fields/InitiativeType/InitiativeType.jsx">
      <SelectInput
        {...initiativeTypeField}
        onChange={() => {
          form?.validate(
            `initiative[initiativeType]`,
            () => {},
            () => {}
          );
        }}
        options={options}
      />
    </ErrorHandler>
  );
}
